/** Reserve → User Permissions → Retail tab (payload keys = area labels) */

export const clientProfileArea = "Client Profile" as const;
export const commissionSetupArea = "Commission Setup" as const;
export const fiscalReportsArea = "Fiscal Reports" as const;
export const interfaceArea = "Interface" as const;
export const inventoryManagementArea = "Inventory Management" as const;
/** Point-of-sale style permissions (section title "Retail" in spec) */
export const retailOperationsArea = "Retail" as const;
export const retailReportsArea = "Retail Reports" as const;
export const retailSetupArea = "Retail Setup" as const;
export const retailTransactionsArea = "Retail Transactions" as const;
export const utilitiesArea = "Utilities" as const;

export const clientProfilePermissionList = [
  "675 - Copy Client Profile",
  "600 - Add New Client Profile",
  "605 - Edit Client Profile",
] as const;

export const commissionSetupPermissionList = [
  "800 - Commission Class Setup",
  "805 - Staff Commission Setup",
] as const;

export const fiscalReportsPermissionList = [
  "2500060",
  "2500055",
  "2500015",
  "2500030",
  "2500035",
  "2500040",
  "2500045",
  "2500020",
  "2500010",
  "2500000",
] as const;

export const interfacePermissionList = [
  "12091 - PMS Integration Setup",
  "2000195 - Catalouge Setup",
  "2000190 - Catalogue Type",
  "2000180 - Digital Invoice Configuration",
  "2000185 - General",
  "2000220",
  "2000215",
  "2000205 - Template Setup",
  "2000200 - Templates",
  "85160 - DataMagine Configuration",
  "2000210 - Digital Invoice Monitor",
] as const;

export const inventoryManagementPermissionList = [
  "8721 – Manual Inventory",
  "8734 - Receiving",
  "8731 - Inventory",
  "8733 - Physical Inventory",
  "8735 - PurchaseOrder",
  "8732 - Transfer",
  "8705 – Freeze Inventory",
  "8730 - Print Barcodes",
  "8710 - Release Inventory",
  "8722 - Inventory Management",
  "8725 – Item Transfer",
  "8715 – Full Inventory Update",
  "8720 - Partial Inventory Update",
] as const;

export const retailOperationsPermissionList = [
  "3080 - Issue External GiftCard",
  "3075 - Issue Visual One GiftCard",
  "3090 - Allow AR Payments",
  "3165 - Price Override",
  "3070 - Apply Custom Discount",
  "3115 - Remove Card on File",
  "3125 - Search Gift Card by Guest Name",
  "3085 - Settle to Group Charge",
  "2500025",
  "3110 - Apply Cost Plus Discount",
  "3155 - Apply Ticket Discount",
  "3035 - Apply Discount",
  "3180",
  "3000 - Create Transaction",
  "3030 - Edit Commission",
  "3020 - Edit Gratuity",
  "3025 - Edit Service Charge",
  "3015 - Apply Commission",
  "3005 - Apply Gratuity",
  "3010 - Apply Service Charge",
  "3150 - Redeem Retail Multipack",
  "3050 - Settle to Credit Card",
  "3135 - Settle to Non Integrated Credit Cards",
  "3045 - Settle to Cash",
  "3190",
  "3055 - Settle to Room Charge",
  "3065 - Settle to Others",
  "3130 - Settle to Hotel Comp",
  "3040 - Tax Exempt",
  "3170",
  "3185",
  "3095 - Settle to Post To Folio",
  "3175",
] as const;

export const retailReportsPermissionList = [
  "8175 - Transaction Extract",
  "8740",
  "8165 - Vendor Inventory Detail",
  "8160 - Inventory Summary by Vendor",
  "8205 - Inventory Valuation Report",
  "8200 - Inventory Value and Activity Report",
  "8190 - Inventory Variance Report",
  "8180 - Purchase Orders Report",
  "8185 - Receiving Report",
  "8170 - Sale by Vendor",
  "8195 - Surcharges Report",
  "1240 - Staff Member Summary Report",
  "1245 - Commission Report",
  "1250 - Gratuity Report",
  "1255 - Service Charge Report",
  "8000 - Shift Report",
  "8005 - Transaction Report",
  "8010 - Revenue Summary",
  "8015 - Correct/Void Report",
  "8020 - Accrual Report",
  "8035 - Sales by Item",
  "8040 - Sale by Category",
  "8045 - Sale by Sub-Category",
  "8050 - Sale by Discount",
  "8055 - MultiPack Items",
  "8060 - Returned Items",
  "8065 - Inventory Summary",
  "8070 - Inventory Detail",
  "8075 - Inventory Wash",
  "8080 - Inventory Transfer",
  "8085 - Inventory Audit Trail",
  "8090 - Transaction Log",
  "8095 - Tax Exempt Sales",
  "8100 - Transaction Detail",
  "8105 - Top Spenders",
  "8140 - Sales Mix Report",
  "8150 - Items Extract",
  "8220",
  "8736 - Inventory on Hand",
  "8225",
  "8215 - Items Under Par",
] as const;

export const retailSetupPermissionList = [
  "7190 - Import Defaults",
  "7180 - Non Integrated Credit Cards",
  "7170 - Item Mapping",
  "7025 - Credit Card Terminal",
  "7105 - Credit Cards",
  "7110 - Gift Cards",
  "7120 - Machine names",
  "7100 - Retail feature configuration",
  "7095 - GST Configuration",
  "7135 - Member Bucket Mapping",
  "7140 - Payment Manager - Outlets",
  "7145 - Payment Manager - PMAgents",
  "7115 - Post type mapping",
  "7130 - Quick Sale Categories",
  "7155 - Resort Finance Post Type Mapping",
  "7150 - Payment Manager - PMSettlers",
  "7175 - Sale Depletion Log",
  "2110 - Vip Type",
  "7030 - Category Group",
  "7055 - Discount Reason",
  "7060 - Discount Type",
  "7065 - Guest Type",
  "7005 - Item Setup",
  "7000 - Outlet Setup",
  "7070 - Payment Methods",
  "7010 - Quick Sale Keys",
  "7035 - Retail Categories",
  "7040 - Retail Sub Categories",
  "7020 - Split Commission Template Setup",
  "7050 - Taxes",
  "7064 - Tier Level",
  "7015 - Unit of Measure",
  "7062 - Vendor Type",
  "7090 - Store Terminal",
  "7080 - Receipt Configuration",
  "7061 - Discount Configuration",
  "7063 - Vendor Setup",
  "7185 - System Setup",
  "7041 - Category Linking",
  "7165 - General Ledger Mapping",
  "7315",
  "7195",
  "7310",
  "7305",
  "7300",
] as const;

export const retailTransactionsPermissionList = [
  "5020 - Modify Posted Commission",
  "5035 - Unsettled Payments",
  "5007 - Correct Transaction",
  "5005 - Void Transaction",
  "5050 - Non Integrated Payment Log",
  "5040 - DataMagine Receipt Log",
  "5045 - Refund Failures",
  "5010 - Return - with Ticket",
  "5015 - Return - without Ticket",
  "5000 - Reopen Transaction",
  "5025 - Reprint Ticket",
  "5030 - Revenue Postings Log",
] as const;

export const utilitiesPermissionList = [
  "15215 - Inventory Staging",
  "100776 - Job Scheduler Configuration",
  "42709 - Add/Edit Discount Mapping",
  "85255 - SFTP",
  "20055 - Distribution List",
  "20040 - Email Templates",
  "16025 - Auto Night Audit",
  "20115",
  "20045 - SMS Templates",
  "101546",
  "2435 - Combine Guest Records",
  "7085 - User/Machine Configuration",
  "20095",
  "15170 - Inventory Sync",
  "15065 - Print Default Configuration",
  "16020 - Quick ID Config",
  "2430 - Day End",
  "100775 - Event Scheduler",
] as const;

export type ReserveRetailPermissionAreaKey =
  | typeof clientProfileArea
  | typeof commissionSetupArea
  | typeof fiscalReportsArea
  | typeof interfaceArea
  | typeof inventoryManagementArea
  | typeof retailOperationsArea
  | typeof retailReportsArea
  | typeof retailSetupArea
  | typeof retailTransactionsArea
  | typeof utilitiesArea;
